"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.freeze");

var _vue = _interopRequireDefault(require("vue"));

var _Ebooks = _interopRequireDefault(require("./account/Ebooks.vue"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Section: eBooks Vue
 * ------------------------------------------------------------------------------
 * Configured section to display a list of purchased ebooks and their download links
 *
 * @namespace ebooksVue
 */


var _default = function _default() {
  function init() {
    new _vue["default"]({
      el: '#ebooksContent',
      render: function render(elem) {
        return elem(_Ebooks["default"], {
          props: {
            data: []
          }
        });
      }
    });
  }

  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;